<template>
  <div style="text-align:center;" class="uploadImageControl">
    <span :title="label ? label + ' ' + placeholder : ''">
      <div
        @click.self="onShowExpandedImage"
        class="image"
        v-bind:style="{ backgroundImage: 'url(' + this.imageUrl + ')', backgroundColor: this.backgroundColor }"
      >
        <v-card elevation="0" :loading="isChunkedLoading" style="background: transparent;">
          <template v-if="this.value">
            <span title="Delete this image">
              <v-btn
                x-small
                color="primary"
                icon
                @click="onDelete"
                style="position:relative; left:50px;"
                class="imagecontrol"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </span>

            <span title="View the image" v-if="!isChunkedLoading">
              <v-btn
                color="primary"
                x-small
                icon
                @click="onShowExpandedImage"
                style="position:relative; left:5px;"
                class="imagecontrol"
              >
                <v-icon>photo</v-icon>
              </v-btn>
            </span>
          </template>

          <div v-if="!this.value" style="padding: 5px; position:relative; top:5px; height: 30px; overflow: hidden; text-overflow: ellipsis; ">{{label}}</div>
          <div
            v-if="!this.value"
            style="position:relative; top:50px; font-size: 12px; line-height: 14px;"
          >{{placeholder}}</div>
        </v-card>
      </div>
    </span>

    <upload-button
      :outlined="true"
      color="primary"
      title="Upload"
      :uniqueId="true"
      v-on:file-update="fileChangedUrl"
      :multiple="false"
      :isLoading="isLoading"
      ref="uploadButton"
    />

    <viewer
      class="images clearfix"
      :images="[imageUrl]"
      ref="viewer"
      @inited="inited"
      :options="imageViewerOptions"
      v-if="showViewer"
    >
      <template slot-scope="scope">
        <img ref="myimg" @load="onImageLoad" :src="imageUrl" :key="imageUrl" class="imagethumb" />
      </template>
    </viewer>
  </div>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import vuetifyToast from "@/vuetifyToast.js";
import { mapGetters, mapActions } from "vuex";
import UploadButton from "./UploadButton";
const env = process.env;
const placeholderImage = "img/image-placeholder.png";
import ChunkedFileUploader from "@/plugins/ChunkedFileUploader";
import { EventBus } from "@/event-bus.js";

import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer/src/component.vue";

export default {
  name: "UploadImage",
  components: { UploadButton, Viewer },
  props: {
    value: { required: true },
    numberUpload: { type: Number },
    backgroundColor: { type: String, default: "#FFFFFF" },
    label: { type: String },
    placeholder: { type: String },
    imageUploadInfo: {
      type: Object,
      required: true, //,

      // validator: (value) => {
      // return value.name && value.uploadUrl && value.bucketName;
      // },
    },
    chunked: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  mounted() {
    this.imageUrl = this.value && !this.isChunkedLoading ? this.value : placeholderImage;
    EventBus.$on('chunkedUploadComplete', this.handleChunkedUploadComplete)
  },
  unmounted() {
    EventBus.$off("chunkedUploadComplete", this.handleChunkedUploadComplete);
  },
  data() {
    return {
      imageUrl: placeholderImage,
      showViewer: false,
      isLoading: false,
      isChunkedLoading: false,
      imageViewerOptions: {
        inline: false,
        button: true,
        navbar: false,
        hidden: this.onImageViewerHidden,
        title: [
          1,
          (image, imageData) =>
            `(${imageData.naturalWidth} × ${imageData.naturalHeight})`,
        ],
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: false,
        keyboard: false,
      },
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal == "" || this.isChunkedLoading) {
        this.imageUrl = "img/image-placeholder.png";
      } else {
        this.imageUrl = newVal;
      }
    },
  },
  methods: {
    handleChunkedUploadComplete(fileUrl) {
      if (this.value === fileUrl) {
        this.isChunkedLoading = false;
        this.imageUrl = fileUrl;
      }
    },
    onImageViewerHidden(e) {
      this.showViewer = false;
    },
    inited(viewer) {
      this.$viewer = viewer;
    },

    onImageLoad(img) {
      this.$viewer.view(0);
      this.isLoading = false;
    },

    onDelete() {
      this.$refs.uploadButton.clear();
      this.$emit("input", "");
    },

    onShowExpandedImage() {
      if (this.imageUrl != "img/image-placeholder.png") {
        this.showViewer = true;
      }
    },
    async fileChangedUrl(file) {
      if (!file) {
        return;
      }
      if (this.chunked) {
        let fileUrl = await this.chunkedUpload(file);
        this.$emit("input", fileUrl);
        vuetifyToast.success("File upload started!");
        this.isChunkedLoading = true;
        return;
      }
      let me = this;
      let type = file.type.split("/")[1];
      if (type == "png" || type == "mp4" || type == "jpg" || type == "jpeg") {
        let vm = this;
        vm.isLoading = true;

        let formData = new FormData();

        let originalName = file.name.split(".");

        let blob = file.slice(0, file.size, file.type);
        let imagePart = this.numberUpload
          ? `${me.imageUploadInfo.name}_${this.numberUpload}`
          : `${me.imageUploadInfo.name}`;
        file = new File(
          [blob],
          `${env.VUE_APP_trimaster}-${imagePart}-${
            file.name.split(".")[0]
          }-${Math.random().toString(36).substring(7)}-${vm.getUser.id}.${
            originalName[originalName.length - 1]
          }`,
          { type: file.type }
        );

        formData.append("file", file);

        Trimaster.post(
          me.imageUploadInfo.uploadUrl,
          vm.getUser.apitoken,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
          {
            bucket: me.imageUploadInfo.bucketName,
          }
        ).then(function (data) {
          vm.isLoading = false;
          if (data[0]) {
            let path = data[0][0];
            me.$emit("input", path);
            vuetifyToast.success("File has been uploaded!");
          } else {
            vuetifyToast.error("An error occurred - " + data[1].message);
          }
        });
      } else {
        vuetifyToast.error(
          "File type is invalid! Please upload png, jpg or mp4 files."
        );
      }
    },
    async chunkedUpload(file) {
      let fileUploader = new ChunkedFileUploader(this.imageUploadInfo);
      return await fileUploader.uploadFile(file);
    }
  },
};
</script>
<style lang="scss">
.uploadImageControl {
  .image {
    width: 100px;
    height: 100px;
    border: 1px solid silver;
    background-size: contain;
    background-position: center;
    margin: auto;
    margin-bottom: 7px;
  }
  label {
    margin-right: 0px;
  }

  .upload-btn {
    margin: 0px !important;
  }

  .imagecontrol {
    opacity: 0.5;
  }

  .imagecontrol:hover {
    opacity: 1;
  }

  .imagethumb {
    display: none;
  }
}
</style>
